<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <bubbles-background></bubbles-background>
        <div class="container shape-container">
          <card shadow class="card-profile mb-4 mt-4 border-0" no-body>

            <card-header title="PLASTICtwist Thessaloniki Event" :icon="{prefix:'fas', iconName: 'calendar-alt'}"
                         :text="pageText"></card-header>
            <div class="container text-center">
              <img class="img-fluid" style="width: auto;height: 300px;" alt="Postcard"  src="../../assets/img/events/ptwist_thessaloniki.jpg">
            </div>
            <div class="px-4 pb-3">
              <div class="mb-4">
                <hr>
                <h1 class="display-3 text-center font-weight-300">Instagram Feed
                  <base-button size="sm" type="primary" class="btn-tooltip"
                               v-tooltip.right-end="'We gather Instagram posts every few minutes, so posts take some time to appear here.'">
                    <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'info' }"/>
                  </base-button>
                </h1>

                <small class="d-block text-uppercase font-weight-bold mb-3">Select hashtag</small>
                <base-button tag="a"
                             class="mb-3 mb-sm-0 text-lowercase"
                             type="button"
                             @click="changeHashtag('ptwistskg')"
                             :class="[ hashtag === 'ptwistskg' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                             :icon="{ prefix: 'fas', iconName: 'hashtag'}">
                  ptwistskg
                </base-button>
                <base-button tag="a"
                             class="mb-3 mb-sm-0 text-lowercase"
                             type="button"
                             @click="changeHashtag('plastictwist')"
                             :class="[ hashtag === 'plastictwist' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                             :icon="{ prefix: 'fas', iconName: 'hashtag'}">
                  plastictwist
                </base-button>
                <div v-if="posts">
                  <div class="row">
                    <div :key="post.shortcode" v-for="post in filteredPosts" class="col-md-4 col-sm-12 mt-4">

                      <iframe style="margin-left: auto; margin-right: auto; display: block;"
                              :src="'https://www.instagram.com/p/'+post.shortcode+'/embed/captioned'" width="100%"
                              height="600"
                              frameborder="0" scrolling="yes" allowtransparency="true"></iframe>
                    </div>
                  </div>
                </div>
                <div v-else-if="loading">
                  <div class="d-flex mt-5 justify-content-center">
                    <img alt="Loading" src="../../assets/img/events/PT_final_signature.gif">
                  </div>
                </div>
                <server-error v-else-if="error"></server-error>
                <no-data-error icon="frown" :text="getNoDataText" v-else-if="noData"></no-data-error>
              </div>
              <div class="d-flex justify-content-center" v-if="maxPosts < 100 && postsMoreThanMax">
                <base-button tag="a"
                             class="mb-3 w-25 mb-sm-0 bg-ptwist text-white"
                             type="button"
                             @click="loadMore">
                  Load more
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'plastictwist-challenge-event',
  data () {
    return {
      hashtag: 'ptwistskg',
      posts: null,
      loading: true,
      error: false,
      noData: false,
      pageText: 'Thessaloniki PLASTICtwist Event',
      maxPosts: 15
    }
  },
  computed: {
    getNoDataText () {
      return 'No Instagram posts found with hashtag #' + this.hashtag
    },
    filteredPosts () {
      return this.posts.filter((post, index) => index < this.maxPosts)
    },
    postsMoreThanMax () {
      if (this.posts) {
        return this.posts.length > 15
      } else return false
    }
  },
  created () {
    this.getInstagramPosts()
  },
  methods: {
    loadMore () {
      this.maxPosts += 5
    },
    changeHashtag (hashtag) {
      this.hashtag = hashtag
      this.getInstagramPosts()
    },
    getInstagramPosts () {
      this.reset()

      let payload = {
        data: {
          hashtag: this.hashtag
        },
        endpoint: 'instagram/posts'
      }
      this.$store
        .dispatch('api/get', payload)
        .then((response) => {
          this.posts = response.data
        }).catch((error) => {
          if (error.response) {
            this.noData = true
          } else {
            this.error = true
          }
        }).finally(() => {
          this.loading = false
        })
    },
    reset () {
      this.posts = null
      this.loading = true
      this.error = false
      this.noData = false
    }
  }
}
</script>
